export enum EAdminViewName {
  INDEX = "index",
  CLIENTES = "clientes",
  USUARIOS = "usuarios",
  VAN_CONFIG = "vanconfig",
  LEAD = "lead",
  INTEGRACOES = "integracoes",
  REGRAS_CO = "regrasco",
  NOTIFICACOES = "notificacoes"
}
